import React from 'react';
import Axios from 'axios';
import ShopProfile from './shopProfile';
/*import '../mainCSS/select.css';*/

export default class SizesSelect extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            sizes: []
        }
    }

    componentDidMount() {
        var url = ShopProfile.getURL() + '/index/reactFetch.php';
        var data = new URLSearchParams({
            event: 'sizes-data',
            categoryID: ShopProfile.getCategoryID(),
            groupID: ShopProfile.getGroupID(),
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                this.setState({
                    sizes: res.data
                })
            })
    }

    slectListShow(name) {
        var div = '';
        var i = 0;
        //Becsukom az összes nyitott select -et
        var cName = '';
        var listName = '';
        div = document.getElementsByClassName('opened');
        for (i = 0; i < div.length; i++) {
            cName = div[i].className;
            const aName = cName.split(" ");
            //visszanevezem az osztályt
            div[i].className = "tighten " + aName[1];
            listName = aName[1] + 's';
            if (name !== listName) {
                document.getElementById(listName).style.display = "none";
            }
        }
        //Kinyitom a megfelelőt
        if (document.getElementById(name).style.display === "none") {
            div = document.getElementsByClassName('tighten size');
            document.getElementById(name).style.display = "block";
            //A tömbben lév elemek checked beállítása
            this.itemChecked();
            for (i = 0; i < div.length; i++) {
                div[i].className = "opened size";
            }
        } else if (document.getElementById(name).style.display === "") {
            div = document.getElementsByClassName('tighten size');
            document.getElementById(name).style.display = "block";
            //A tömbben lév elemek checked beállítása
            this.itemChecked();
            //megforgatom arrow irányát
            for (i = 0; i < div.length; i++) {
                div[i].className = "opened size";
            }
        } else {
            document.getElementById(name).style.display = "none";
            //visszaforgatom arrow irányát
            div = document.getElementsByClassName('opened size');
            for (i = 0; i < div.length; i++) {
                div[i].className = "tighten size";
            }
        }
    }

    sizeSearch(sizes, size) {
        var key = '';
        for (var i = 0; i < sizes.length; i++) {
            if (sizes[i] === size) {
                key = sizes[i];
            }
        }
        return key;
    }

    selectedItem(name, id) {
        var sizes = ShopProfile.getSizes();
        var size = this.sizeSearch(sizes, name);
        if (document.getElementById(name).checked === true) {
            document.getElementById(name).checked = false;
            if (size !== '') {
                ShopProfile.delSize(name);
                ShopProfile.delSizeID(id);
            }
        } else {
            document.getElementById(name).checked = true;
            if (size === '') {
                ShopProfile.addSize(name);
                ShopProfile.addSizeID(id);
            }
        }
    }

    itemsList(sizes, name) {
        const res = sizes.map((size) =>
            <li key={size.nev} onClick={() => this.selectedItem(size.nev, size.meretekID)}>
                {size.nev}
                <span>
                    <input id={size.nev} type='checkbox' onClick={() => this.selectedItem(size.nev)} />
                </span>
            </li>
        );
        return <ul id={name}> {res} </ul>;
    }

    itemChecked() {
        var sizes = ShopProfile.getSizes();
        for (var i = 0; i < sizes.length; i++) {
            var id = sizes[i];
            var checkBox = document.getElementById(id);
            checkBox.checked = true;
        }
    }

    render() {
        var { sizes } = this.state;
        var show = false;
        var sizesList = this.itemsList(sizes, 'sizes');
        var i = 0;
        //sajnos két tömbböt dob
        for (i = 0; i < sizes.length; i++) {
            show = true;
        }
        if (show === true) {
            return (
                <div className='tighten size'>
                    <div onClick={() => this.slectListShow('sizes')}>
                        <h3>Méretek<label></label></h3>
                    </div>
                    {sizesList}
                </div>
            )
        } else {
            return null;
        }
    }
}